import {UsersListSearchComponent} from './UsersListSearchComponent'

const UsersListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent />
    </div>
  )
}

export {UsersListHeader}
